import { Route } from 'react-router';
import { importOrReload } from '@/utils/route.utils';
import { adminRoutes } from './admin.routes';

export const supportRoutes = (
  <Route
    path="support"
    lazy={importOrReload(() => import('@/pages/support/layout'))}
  >
    <Route
      path="index?"
      index
      lazy={importOrReload(() => import('@/pages/support/select-only-org'))}
    />
    <Route
      path="login"
      lazy={importOrReload(() => import('@/pages/support/login/page'))}
    />

    {adminRoutes}

    <Route
      path=":orgId"
      lazy={importOrReload(() => import('@/pages/support/org/layout'))}
    >
      <Route
        path=":countryId"
        lazy={importOrReload(() => import('@/pages/support/country/layout'))}
      >
        <Route
          path="client"
          lazy={importOrReload(() => import('@/pages/support/client/layout'))}
        >
          <Route
            index
            path="list?"
            lazy={importOrReload(() => import('@/pages/support/client/page'))}
          />
          <Route
            path=":slug"
            lazy={importOrReload(
              () => import('@/pages/support/client/[slug]/layout')
            )}
          >
            <Route path="calendar" element={<>Calendar</>} />
            <Route
              path="events"
              lazy={importOrReload(
                () => import('@/pages/support/client/[slug]/events/page')
              )}
            >
              {['create', ':eventId'].map((path) => (
                <Route
                  key={path}
                  path={path}
                  lazy={importOrReload(
                    () =>
                      import('@/pages/support/client/[slug]/events/form/page')
                  )}
                />
              ))}
            </Route>
            <Route
              path="settings?"
              lazy={importOrReload(
                () => import('@/pages/support/client/[slug]/settings/page')
              )}
            />
            <Route
              path="locations"
              lazy={importOrReload(
                () => import('@/pages/support/client/[slug]/locations/page')
              )}
            >
              <Route
                path="location"
                lazy={importOrReload(
                  () =>
                    import('@/pages/support/client/[slug]/locations/location/page')
                )}
              >
                <Route
                  path=":locationId"
                  lazy={importOrReload(
                    () =>
                      import('@/pages/support/client/[slug]/locations/location/[locationId]/page')
                  )}
                />
              </Route>
            </Route>

            <Route
              path="*"
              lazy={importOrReload(() => import('@/pages/not-found'))}
            />
          </Route>
        </Route>
        <Route
          path="active-events"
          lazy={importOrReload(
            () => import('@/pages/support/active-events/page')
          )}
        />
        <Route
          path="members-report"
          lazy={importOrReload(
            () => import('@/pages/support/members-report/page')
          )}
        />
        <Route
          path="appointments-report"
          lazy={importOrReload(
            () => import('@/pages/support/appointments-report/page')
          )}
        />
      </Route>
    </Route>
  </Route>
);
